export default class TransientError extends Error {
  originalErr: Error | null

  name = 'TransientError'

  constructor(message: string, originalErr: Error | null = null) {
    super(message)
    this.originalErr = originalErr
  }
}
